import styled from 'styled-components';

export const ActivityCardContainer = styled.div`
  .code-status {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .status {
    color: ${(props) => props.theme.colors.successMessage};
    svg {
      fill: none;
      stroke: ${(props) => props.theme.colors.successMessage};
    }
  }

  button {
    margin-left: auto;
  }

  .description {
    max-width: 75%;
  }
`;

export const SectionContainer = styled.div`
  .section-title {
    margin-top: 48px;
  }
`;
